import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type CuratedPost = {
  id: string;
  slug: string;
  title: string;
  summary: string | null;
  body_md: string | null;
  cover_image_url: string | null;
  category: string | null;
  tags: string[];
  source_org_name: string;
  source_url: string;
  source_logo_url: string | null;
  attribution_note: string | null;
  claim_contact_email: string | null;
  status: string;
  published_at: string | null;
  created_at: string;
  updated_at: string;
};

export function useCuratedPosts(opts?: { includeDrafts?: boolean }) {
  return useQuery({
    queryKey: ["curated_posts", { includeDrafts: !!opts?.includeDrafts }],
    queryFn: async () => {
      let q = supabase.from("curated_posts").select("*").order("published_at", {
        ascending: false,
        nullsFirst: false,
      });
      if (!opts?.includeDrafts) q = q.eq("status", "published");
      const { data, error } = await q;
      if (error) throw error;
      return (data ?? []) as unknown as CuratedPost[];
    },
  });
}

export function useCuratedPostBySlug(slug: string | undefined) {
  return useQuery({
    enabled: !!slug,
    queryKey: ["curated_post", slug],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("curated_posts")
        .select("*")
        .eq("slug", slug!)
        .maybeSingle();
      if (error) throw error;
      return data as unknown as CuratedPost | null;
    },
  });
}